import { Alert, Typography } from 'antd';

const { Text } = Typography;

interface CaptionProps {
  show: boolean;
  message: string;
}

export function DiffCaption({ show, message }: CaptionProps) {
  if (!show) return null;
  // marginBottom clears the next FloatingField's floating-label, which sits
  // at `top: 0; translateY(-50%)` and extends ~6px above its own container.
  // Without it, the caption overlaps the floating label of the field below.
  return (
    <Text
      type="warning"
      style={{ fontSize: 11, display: 'block', marginTop: 2, marginBottom: 10 }}
    >
      {message}
    </Text>
  );
}

interface BannerProps {
  show: boolean;
}

export function DiffBanner({ show }: BannerProps) {
  if (!show) return null;
  return (
    <Alert
      type="warning"
      showIcon
      message="Thông tin xuất HĐ khác thông tin giao hàng — vui lòng kiểm tra trước khi ghi đơn."
      style={{ marginTop: 8, fontSize: 11 }}
    />
  );
}
